/**
 * Hooks de comentarios de tareas.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import type { TaskCommentsInsert } from '@/types/database.types';

import * as commentsApi from '../api/taskComments';
import { TASK_KEYS } from './keys';

export function useTaskComments(taskId: string) {
  return useQuery({
    queryKey: TASK_KEYS.comments(taskId),
    queryFn: () => commentsApi.listComments(taskId),
    enabled: !!taskId,
  });
}

export function useAddComment(taskId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: TaskCommentsInsert) => commentsApi.addComment(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: TASK_KEYS.comments(taskId) });
    },
    onError: (error: Error) =>
      toast.error('No se pudo comentar', { description: error.message }),
  });
}
